/**
 * Jessie's Home — PDP compact discount ticket
 * Clipboard + /discount/{code}, cart.js applied check, countdown, variant price.
 */
(function () {
  'use strict';

  var pad = function (n) {
    return String(n).padStart(2, '0');
  };

  var dateLabel = function (d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  };

  function formatMoney(cents, moneyFormat) {
    cents = Number(cents);
    if (!isFinite(cents)) return '';
    var format = moneyFormat || '${{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var withComma = amount.replace('.', ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function parseEnds(iso) {
    if (!iso) return null;
    var t = Date.parse(iso);
    if (!isNaN(t)) return t;
    var fixed = String(iso).replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    t = Date.parse(fixed);
    return isNaN(t) ? null : t;
  }

  function onShopifyStore() {
    if (window.Shopify && Shopify.shop) return true;
    var host = location.hostname || '';
    return host.indexOf('myshopify.com') !== -1 || host.indexOf('jessieshome') !== -1;
  }

  function initDisc(el) {
    if (!el || el.__jhDiscInit) return;
    el.__jhDiscInit = true;

    var code = String(el.getAttribute('data-code') || '').toUpperCase();
    var pct = parseFloat(el.getAttribute('data-percent') || '0') || 0;
    var price = parseInt(el.getAttribute('data-price') || '0', 10) || 0;
    var endsMs = parseEnds(el.getAttribute('data-ends') || '');
    var moneyFormat = el.getAttribute('data-money-format') || '${{amount}}';

    var q = function (s) {
      return el.querySelectorAll(s);
    };
    var set = function (s, v) {
      q(s).forEach(function (n) {
        n.textContent = v;
      });
    };

    function finalCents(cents) {
      return Math.round((Number(cents) * (100 - pct)) / 100);
    }

    function render() {
      set('[data-jh-final]', formatMoney(finalCents(price), moneyFormat));
      el.setAttribute('data-price', String(price));
    }

    function tick() {
      if (!endsMs) return false;
      var ms = endsMs - Date.now();
      if (ms <= 0) {
        el.hidden = true;
        return false;
      }
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400);
      var text =
        d >= 2
          ? 'ends ' + dateLabel(new Date(endsMs))
          : d === 1
            ? 'ends tomorrow'
            : 'ends in ' + pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      set('[data-jh-countdown]', text);
      return true;
    }

    function markApplied() {
      el.classList.add('is-applied');
      q('[data-jh-apply]').forEach(function (b) {
        b.setAttribute('aria-disabled', 'true');
      });
    }

    function copyCode() {
      if (!code) return Promise.resolve();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(code).catch(function () {
          fallbackCopy(code);
        });
      }
      fallbackCopy(code);
      return Promise.resolve();
    }

    function fallbackCopy(text) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) {}
    }

    function apply() {
      if (el.classList.contains('is-applied')) return Promise.resolve();
      copyCode();
      var req = onShopifyStore()
        ? fetch('/discount/' + encodeURIComponent(code), {
            credentials: 'same-origin',
            keepalive: true,
          }).catch(function () {})
        : Promise.resolve();
      return Promise.resolve(req).then(markApplied);
    }

    q('[data-jh-apply]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        apply();
      });
    });

    if (onShopifyStore() && code) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (d) {
            return String(d.code).toUpperCase();
          });
          if (codes.indexOf(code) !== -1) markApplied();
        })
        .catch(function () {});
    }

    function updatePrice(cents) {
      if (cents == null || isNaN(cents)) return;
      price = Number(cents);
      render();
    }

    function updateFromVariant(variant) {
      if (!variant) return;
      var cents = variant.price != null ? Number(variant.price) : null;
      updatePrice(cents);
    }

    function updateFromIdInput() {
      var scope = el.closest('product-info, .product, section') || document;
      var idInput = scope.querySelector('input[name="id"], select[name="id"]');
      if (!idInput || !idInput.value) return;
      var mapEl = el.parentNode && el.parentNode.querySelector('script[data-jh-variant-prices]');
      var map = {};
      if (mapEl) {
        try {
          map = JSON.parse(mapEl.textContent);
        } catch (e) {
          map = {};
        }
      }
      var key = String(idInput.value);
      if (map[key] != null) updatePrice(Number(map[key]));
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        updateFromVariant(variant);
      });
    }

    document.addEventListener('jh:variant-change', function (e) {
      if (!e || !e.detail) return;
      if (e.detail.price != null) {
        updatePrice(+e.detail.price);
        return;
      }
      updateFromVariant(e.detail.variant || e.detail);
    });

    var productInfo = el.closest('product-info');
    if (productInfo) {
      productInfo.addEventListener('variant:change', function (e) {
        updateFromVariant((e.detail && (e.detail.variant || e.detail)) || null);
      });
      productInfo.addEventListener('variantChange', function (e) {
        updateFromVariant((e.detail && (e.detail.variant || e.detail)) || null);
      });
    }

    var scope = el.closest('product-info, .product, section') || document;
    scope.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name === 'id' || t.matches('[name="id"]') || t.closest('variant-selects, variant-radios, fieldset')) {
        setTimeout(updateFromIdInput, 0);
      }
    });

    render();
    if (endsMs && tick()) {
      setInterval(function () {
        tick();
      }, 1000);
    }
  }

  function boot() {
    document.querySelectorAll('[data-jh-disc]').forEach(initDisc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
